export class GatewayType {

    private internalId: string;
    private code: string;
    private description: string;

    constructor(internalId?: string, code?: string, description?: string) {
        this.internalId = internalId;
        this.code = code;
        this.description = description;
    }

    public get InternalId() {
        return this.internalId;
    }

    public get Code() {
        return this.code;
    }

    public get Description() {
        return this.description;
    }

    public set InternalId(internalId) {
        this.internalId = internalId;
    }

    public set Code(code) {
        this.code = code;
    }

    public set Description(description) {
        this.description = description;
    }
}